'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = shimLogger;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// This will be removed when we externalize all logging
// out of the VI and VPE repos and into their own modules.

var LOAD_TIME = 'LoadTime';
var LOAD_TIME_LIMIT = 180000;

function shimLogger(logger) {
  return function () {
    function LoggerShim(loggerName, playerInstance) {
      _classCallCheck(this, LoggerShim);

      /** @ignore */
      this._loggerName = loggerName;
      /** @ignore */
      this._player = playerInstance;

      var playerConfig = playerInstance.config;

      var packageInfo = {
        name: playerConfig.packageName,
        version: playerConfig.packageVersion
      };

      if (typeof playerConfig.loggerCallback !== 'undefined') {
        /** @ignore */
        this._loggerCallback = playerConfig.loggerCallback;
      }

      /** @ignore */
      this._loggerInfo = {
        app: 'Hudl',
        op: 'VideoPlayback',
        pageURL: window.location.href,
        cluster: 'N/A'
      };

      this._libraryInfo = {
        playerName: playerInstance.name,
        playerVersion: playerInstance.version
      };

      if (packageInfo) {
        this._libraryInfo.libraryName = playerConfig.packageName;
        this._libraryInfo.libraryVersion = playerConfig.packageVersion;
      }

      /** @ignore */
      this._isSilent = !playerConfig.log;
      /** @ignore */
      this._cdnlessLogs = [];
      /** @ignore */
      this._queuedLogs = [];
      /** @ignore */
      this._logTimes = {};
    }
    /**
     * Gets the logger times object.
     * @return {object} - The logger times object
     */


    _createClass(LoggerShim, [{
      key: 'logTime',


      /**
       * Logs the time for a certain event type.
       * @param {string} event - The event type string
       * @param {number} time - The time to record
       */
      value: function logTime(event, time) {
        if (event === LOAD_TIME && time > LOAD_TIME_LIMIT) {
          this.logIssue('LoadTimeOverLimit', {
            message: 'LoadTime over 3 minutes',
            loadTime: time
          });
        }

        var attributes = {
          libraryInfo: this._libraryInfo,
          videoEvent: _defineProperty({}, event, Number(time.toFixed(2)))
        };

        this.sendLog({
          func: 'Timing',
          attributes: attributes
        });
      }

      /**
       * Logs the quality for a certain event type.
       * @param {string} event - The event type string
       * @param {?object} info - The object containing relevant logging information
       */

    }, {
      key: 'logQuality',
      value: function logQuality(event, info) {
        this.sendLog({
          func: 'Quality',
          event: event,
          value: info
        });
      }

      /**
       * Logs any issue for a certain event type.
       * @param {string} event - The event type string
       * @param {?object} info - The object containing relevant logging information
       */

    }, {
      key: 'logIssue',
      value: function logIssue(event, info) {
        this.sendLog({
          func: 'Issue',
          event: event,
          value: info
        });
      }
    }, {
      key: 'sendCdnlessLogs',
      value: function sendCdnlessLogs() {
        // no-op for this logger. Handled by Inisghts.
        return;
      }

      /**
       * Prints logs to the console (for now)
       * @param {object} data - The logging event data object
       * @private
       */

    }, {
      key: 'sendLog',
      value: function sendLog(data) {
        logger(data);
      }
    }, {
      key: 'times',
      get: function get() {
        return this._logTimes;
      }

      /**
       * Sets the logger times object.
       * @param {object} data - The logger times object
       */
      ,
      set: function set(data) {
        this._logTimes = data;
      }
    }]);

    return LoggerShim;
  }();
}
module.exports = exports['default'];